import { useId } from 'react';

type PendingReviewWarningClipboardWatermarkProps = {
  className?: string;
};

/** Decorative clipboard with warning badge watermark for employer pending-review card. */
export const PendingReviewWarningClipboardWatermark = ({
  className = '',
}: PendingReviewWarningClipboardWatermarkProps) => {
  const uid = useId().replace(/:/g, '');
  const gradientId = `pendingReviewWarnGrad-${uid}`;

  const renderScene = () => (
    <g transform="rotate(-30 50 50)">
      <rect x="18" y="10" width="64" height="80" fill="#AAAAAA" stroke="#222222" strokeWidth="5" />
      <rect x="25" y="20" width="50" height="60" fill="#EBEBDA" stroke="#000000" strokeWidth="2" />
      <line x1="35" y1="30" x2="65" y2="30" stroke="#000000" strokeWidth="2" />
      <line x1="35" y1="40" x2="65" y2="40" stroke="#000000" strokeWidth="2" />
      <line x1="35" y1="50" x2="65" y2="50" stroke="#000000" strokeWidth="2" />
      <polygon points="40,7 60,7 65,20 35,20" fill="#000000" />
      <g transform="scale(0.6) translate(56 56)">
        <path
          d="M 96,81 61,12 C 57,2.7 43,2.7 39,12 39,12 5.4,78 3.4,83 c -2,5 0,12 8.6,12 l 71,0 c 12,0 17,-5 13,-14 z"
          fill="none"
          stroke="#DC9B1D"
          strokeWidth="3"
        />
        <path
          d="M 91,80 58,16 C 54,7.1 46,7.1 42,16 42,16 11,77 9,81 6.2,86 5.8,91 14,91 l 67,0 c 12,0 14,-3 10,-11 z"
          fill={`url(#${gradientId})`}
          stroke="#444444"
          strokeWidth="7"
        />
        <path d="M 46,63 43,35 57,35 54,63 z" fill="#333333" />
        <circle cx="50" cy="73" r="7" fill="#333333" />
      </g>
    </g>
  );

  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradientId} x1="20" y1="60" x2="60" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#C07F00" offset="0" />
          <stop stopColor="#FFB85B" offset="1" />
        </linearGradient>
      </defs>

      <g className="dark:hidden" opacity="0.24">
        {renderScene()}
      </g>
      <g className="hidden dark:block" opacity="0.28">
        {renderScene()}
      </g>
    </svg>
  );
};
